





























import * as _ from 'lodash';
import $ from 'jquery';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

import { Language, VisitorType } from '../../types/Enum';

@Component({
  components: {
  },
})
export default class Authentification extends Vue {
    private start: boolean = false;

    private login: boolean = false;

    private today: Date = new Date();

    private hours: string = '';

    private date: string = '';

    private days: string[] = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];

    private months:string[] = ['Janvier', 'Fevrier', 'Mardi', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Saptembre', 'Octobre', 'Novembre', 'Decembre'];

    private visitor: VisitorType = VisitorType.None;

    public getDate() : string {
      return `${this.days[this.today.getDay()]} ${this.today.getDate()} ${this.months[this.today.getMonth()]}`;
    }

    public getHours() : string {
      const pad:Function = (nbr: number) => ((nbr < 10) ? `0${nbr}` : `${nbr}`);
      return `${this.today.getHours()}:${pad(this.today.getDate())}`;
    }

    private logUser() {
      const element: Element = (this.$refs.noblured as Element);
      $(element).toggleClass('blur-it');
      this.login = !this.login;
      setTimeout(() => {
        this.$root.$emit('TypeWritter::Animation::End');
      }, 2000);
    }

    public mounted() {
      this.today = new Date();
      this.$root.$on('App::Animation::End', () => {
        this.start = true;
      });
      setInterval(() => {
        this.date = this.getDate();
        this.hours = this.getHours();
      }, 1000);
    }

    private setVisitor(type: VisitorType): void {
      this.visitor = type;
    }
}
